/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ==========================================================
 * COLOURLIVING - EU GEWÄHRLEISTUNG MODAL
 * ========================================================== */

(function () {
  let activeWarrantyModal = null;
  let warrantyTrigger = null;

  function openWarrantyModal(button) {
  const modalId = button.getAttribute("data-cl-warranty-open");

  /*
   * First look for an already-portaled modal directly under <body>.
   * This keeps the modal outside Warehouse's product-card
   * stacking/scrolling contexts.
   */
  let modal = document.querySelector(
    `body > #${modalId}.cl-warranty-modal`
  );

  /*
   * First opening:
   * find the modal where Liquid originally rendered it,
   * then physically move that SAME element to <body>.
   */
  if (!modal) {
    modal = document.getElementById(modalId);

    if (!modal) {
      return;
    }

    document.body.appendChild(modal);
  }

  /*
   * Warehouse may rerender product-meta after a variant change.
   * If Liquid produced another copy of the same modal,
   * remove that duplicate and keep the body-level version.
   */
  document
    .querySelectorAll(`#${modalId}.cl-warranty-modal`)
    .forEach(function (otherModal) {
      if (otherModal !== modal) {
        otherModal.remove();
      }
    });

  warrantyTrigger = button;
  activeWarrantyModal = modal;

  modal.classList.add("is-open");
  modal.setAttribute("aria-hidden", "false");

  document.documentElement.classList.add(
    "cl-warranty-open"
  );

  document.body.classList.add(
    "cl-warranty-open"
  );

  const closeButton = modal.querySelector(
    ".cl-warranty-modal__close"
  );

  if (closeButton) {
    setTimeout(function () {
      closeButton.focus();
    }, 10);
  }
}
  function closeWarrantyModal() {
    if (!activeWarrantyModal) {
      return;
    }

    activeWarrantyModal.classList.remove("is-open");
    activeWarrantyModal.setAttribute("aria-hidden", "true");

    document.documentElement.classList.remove(
      "cl-warranty-open"
    );

    document.body.classList.remove(
      "cl-warranty-open"
    );

    if (warrantyTrigger) {
      warrantyTrigger.focus();
    }

    activeWarrantyModal = null;
    warrantyTrigger = null;
  }

  document.addEventListener("click", function (event) {

    const openButton = event.target.closest(
      "[data-cl-warranty-open]"
    );

    if (openButton) {
      event.preventDefault();

      openWarrantyModal(openButton);

      return;
    }

    const closeButton = event.target.closest(
      "[data-cl-warranty-close]"
    );

    if (closeButton) {
      event.preventDefault();

      closeWarrantyModal();
    }
  });

  document.addEventListener("keydown", function (event) {

    if (
      event.key === "Escape" &&
      activeWarrantyModal
    ) {
      closeWarrantyModal();
    }

  });
})();
